import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../../config/firebase';
import {
  signInWithEmailAndPassword,
} from 'firebase/auth';
import axios from 'axios';
import './Login.css';
import Alert from '../../components/Alert/Alert';
import Footer from '../../components/Footer/Footer';
import LogoMinymol from '../../components/LogoMinymol/LogoMinymol';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const Login = () => {
  const [cell, setCell] = useState('');
  const [password, setPassword] = useState('');
  const [showPass, setShowPass] = useState(false);
  const navigate = useNavigate();
  const [alert, setAlert] = useState(null);

  const sendTokenToBackend = async (token) => {
    try {
      const response = await axios.post(
        'https://api.minymol.com/auth/login',
        { token }
      );

      const userData = response.data;

      localStorage.setItem('usuario', JSON.stringify(userData));
      localStorage.setItem('token', token);

      navigate('/');
    } catch (error) {
      console.error('Error desde el backen:', error);
      if (error.response?.status === 401) {
        setAlert({
          type: 'error',
          message: 'Token inválido o usuario no autorizado',
        });
      } else {
        setAlert({
          type: 'error',
          message: 'No se pudo autenticar con el servidor',
        });
      }
    }
  };

  const loginWithEmail = async (e) => {
    e.preventDefault();

    const isEmail = cell.includes('@');
    const fakeEmail = isEmail ? cell.trim().toLowerCase() : cell.replace('+', '') + '@minymol.com';

    try {
      const result = await signInWithEmailAndPassword(auth, fakeEmail, password);
      const token = await result.user.getIdToken();
      await sendTokenToBackend(token);
    } catch (err) {
      console.error('Error con correo/contraseña:', err);
      setAlert({
        type: 'error',
        message: 'Correo o contraseña incorrectos',
      });
    }
  };

  return (
    <>
      {alert && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
          redirectTo={alert.redirectTo}
        />
      )}
      <div className="login-ps-cont">
        <LogoMinymol />
        <p id='p-login'>Inicia sesión</p>
        <form onSubmit={loginWithEmail}>
          <label>Número de celular</label>
          <input
            type="text"
            required
            placeholder="Ej.: 3101234567"
            value={cell}
            onChange={(e) => setCell(e.target.value)}
            className='input-email-login'
          />

          <label>Contraseña</label>
          <div className="pass-input-lg">
            <input
              type={showPass ? 'text' : 'password'}
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <span className="toggle-pass" onClick={() => setShowPass(!showPass)}>
              <FontAwesomeIcon icon={showPass ? faEyeSlash : faEye} />
            </span>
          </div>
          <Link to={'/recuperar-contrasena'} className='remember'> ¿Olvidaste tu contraseña? </Link>
          <button className='btn-login' type="submit">Continuar</button>
        </form>

        <p className='p-login'>¿No tienes cuenta? <Link to="/register" className='remember'>Regístrate</Link></p>
      </div>

      <Footer />
    </>
  );
};

export default Login;
